import { TextField } from "@mui/material";
import { styled } from "@mui/material";

const Input = styled(TextField)(({ theme }) => ({
	"& .MuiOutlinedInput-root": {
		borderRadius: 0,
		"& fieldset": {
			borderRadius: 0,
			borderColor: theme.palette.background.black,
		},
		"&.Mui-focused fieldset": {
			borderRadius: 0,
		},
	},
	"& .MuiOutlinedInput-input:-webkit-autofill": {
		borderRadius: 0,
	},
}));

export default Input;
